import MasterDetail from "../components/datagrid/DeviceGrid";
import { Box } from "@mui/material";

const Devices = () => {
  return (
    <Box>
      <MasterDetail />
    </Box>
  );
};
export default Devices;
